<template>
    <div class="special-box">
        <div class="head-box">
            <img class="banner-bg" :src="bg" alt="">
            <div class="title-box">{{ specialData.name }}</div>
        </div>
        <div class="summary-box">
            <div class="summary">
                <div class="summary-text">{{ specialData.summary }}</div>
                <div class="summary-num">共{{ specialData.countNews }}条内容</div>
            </div>
            <img class="special-zy-bg-title" src="../../../static/img/special-zy-bg-title.png" alt="">
        </div>
        <div class="special-list">
            <a v-for="(item, i) in littleSpecialData" :key="i" @click="clickTab(item.id,i)">{{ item.name }}</a>
        </div>
        <div class="little-special-list">
            <div class="special-list-item">
                <template v-for="(item, i) in littleSpecialData">
                  <div class="special-title" v-if="i==activeLi" :id="item.id" :key="i" >
                      <span>
                          <h5>{{ item.name }}</h5><i class="border-bottm"></i>
                      </span>
                  </div>
                </template>
                <div class="news-list"
                v-infinite-scroll="getChildList"
                infinite-scroll-disabled="busy"
                infinite-scroll-distance="100"
                >
                    <!-- {{ newSubList }} -->
                    <template  v-for="(itemnews, j) in newSubList">
                        <a class="news-item img1" v-if="itemnews.ifVideo == 1 && itemnews.isShowLarge == 0 && (itemnews.imgStr.length == 1 || itemnews.imgStr.length == 2)" @click="toDetail(itemnews.id , itemnews.title , itemnews.outUrl)">
                            <div class="news-title-box">
                                <div class="title">{{ itemnews.title }}</div>
                                <div class="sur-date">
                                    <span>{{ itemnews.source }}</span><span>{{ itemnews.formatPublicTime }}</span>
                                </div>
                            </div>
                            <img class="img-1" :src="itemnews.focusPic" alt="">
                        </a>
                        <a class="news-item video-box" v-if="itemnews.ifVideo == 1 && itemnews.isShowLarge == 1 && (itemnews.imgStr.length == 1 || itemnews.imgStr.length == 2)" @click="toDetail(itemnews.id , itemnews.title , itemnews.outUrl)">
                            <div class="title">{{ itemnews.title }}</div>
                            <div class="img-box">
                              <img class="video-img" :src="itemnews.focusPic" alt="">
                            </div>
                            <div class="sur-date">
                                <span>{{ itemnews.source }}</span><span>{{ itemnews.formatPublicTime }}</span>
                            </div>
                        </a>
                        <a class="news-item img1" v-if="itemnews.ifVideo == 1 && itemnews.imgStr.length == 0" @click="toDetail(itemnews.id , itemnews.title , itemnews.outUrl)">
                            <div class="news-title-box">
                                <div class="title">{{ itemnews.title }}</div>
                                <div class="sur-date">
                                    <span>{{ itemnews.source }}</span><span>{{ itemnews.formatPublicTime }}</span>
                                </div>
                            </div>
                        </a>
                        <a class="news-item img2" v-if="itemnews.ifVideo == 1 && itemnews.isShowLarge == 0 && itemnews.imgStr.length == 3" @click="toDetail(itemnews.id , itemnews.title , itemnews.outUrl)">
                            <div class="title">{{ itemnews.title }}</div>
                            <div class="img-box">
                                <img v-for="(itemimg, m) in itemnews.imgStr" :key="m" class="img-1" :src="itemimg"
                                    alt="">
                            </div>
                            <div class="sur-date">
                                <span>{{ itemnews.source }}</span><span>{{ itemnews.formatPublicTime }}</span>
                            </div>
                        </a>
                        <a class="news-item video-box" v-if="itemnews.ifVideo == 1 && itemnews.isShowLarge == 1 && itemnews.imgStr.length == 3" @click="toDetail(itemnews.id , itemnews.title , itemnews.outUrl)">
                            <div class="title">{{ itemnews.title }}</div>
                            <div class="img-box">
                              <img class="video-img" :src="itemnews.focusPic" alt="">
                            </div>
                            <div class="sur-date">
                                <span>{{ itemnews.source }}</span><span>{{ itemnews.formatPublicTime }}</span>
                            </div>
                        </a>
                        <a class="news-item video-box" v-if="itemnews.ifVideo == 0" @click="toDetail(itemnews.id , itemnews.title , itemnews.outUrl)">
                            <div class="title">{{ itemnews.title }}</div>
                            <div class="img-box">
                              <img class="video-img" :src="itemnews.focusPic" alt="">
                              <img class="video-btn" src="../../../static/img/video-btn-icon.png" alt="">
                            </div>
                            <div class="sur-date">
                                <span>{{ itemnews.source }}</span><span>{{ itemnews.formatPublicTime }}</span>
                            </div>
                        </a>
                    </template>
                    <div v-if="dataLoadNomore" class="loading-all">没有更多数据</div>
                    <div v-else class="loading">正在加载中，请稍等…</div>
                </div>
            </div>
        </div>
        <div v-if="isWX" class="download">
            <div>
                <img src="/static/shareLogo.png" alt="大河网" />
                <span>下载大河网APP</span>
            </div>
            <a href="/m/download">立即下载</a>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import store from "@/store";
import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
import { Notification } from 'element-ui';
import { mapActions } from "vuex";
import infiniteScroll from "vue-infinite-scroll";
Vue.use(preview);
export default {
    name: "MDetail",
    directives: { infiniteScroll },
    data() {
        return {
            bg: '',
            subjectId: this.$route.params.id,
            specialData: [],
            littleSpecialTitle: [],
            littleSpecialData: [],
            isWX: false,
            subname:'',
            activeLi:0,
            newSubList:[],
            busy: false,
            dataLoadNomore: false,
            page: 1,
            size: 10,
            subjectIdChild:''
        }
    },
    // mounted() {
    //   // 在组件挂载后立即加载第一页数据
    //   this.getData();
    // },
    methods: {
      async getData() {
            this.$api
                .subjectList({
                    subjectId: this.subjectId
                })
                .then((res) => {
                    this.specialData = res.data.data;

                    this.$nextTick(() => {
                        window.wxShareData = JSON.stringify({name:res.data.data.name,summary:res.data.data.summary});
                    });
                    this.wxshare(res.data.data.name,res.data.data.summary);
                    let app = this.getEnv();
                    if (app == "android") {
                        android.shareData(res.data.data.name,res.data.data.summary);
                    }
                    // this.bg = 'background: url(' + res.data.data.focusImg + ') no-repeat center center;'
                    this.bg = res.data.data.focusImg;
                    // res.data.data.childList.forEach((item, index) => {
                    //     item.newsList.forEach((itemnews, t) => {
                    //         if (itemnews.imgStr) {
                    //             itemnews.imgStr = itemnews.imgStr.split(",");
                    //         } else {
                    //             itemnews.imgStr = [];
                    //         }
                    //     })
                    // });
                    this.littleSpecialData = res.data.data.childList;
                    this.subname=res.data.data.childList[0].name;
                    this.subjectIdChild = res.data.data.childList[0].id;
                    this.activeLi = 0;
                    this.getChildList()
                });
        },
        clickTab(id,i){
          this.subjectIdChild = id;
          this.activeLi = i;
          this.page = 1;
          this.newSubList = [];
          this.getChildList()
        },
        async getChildList(){
            this.busy = true;
            if(this.subjectIdChild == ''){
              this.getData();
              return false
            }
            this.$api.subNewsList({
              type:1,
              subjectId:this.subjectIdChild ? this.subjectIdChild : this.subjectId,
              current:this.page,
              size:this.size
            })
            .then((res)=>{
                // this.newSubList=res.data.data.records;
                res.data.data.records.forEach((itemnews, t) => {
                            if (itemnews.imgStr) {
                                itemnews.imgStr = itemnews.imgStr.split(",");
                            } else {
                                itemnews.imgStr = [];
                            }
                        })
                this.newSubList = this.newSubList.concat(
                  res.data.data.records
                );
                if (res.data.data.current < res.data.data.pages) {
                  this.page += 1;
                  this.busy = false;
                  this.dataLoadNomore = false;
                } else {
                  this.dataLoadNomore = true;
                }
            })
        },
        getUserInfo() {
            let app = this.getEnv();
            this.isWX = false;
            if (app == "ios") {
                this.isWX = false;
            } else if (app == "android") {
                this.isWX = false;
            } else {
                this.isWX = true;
            }
        },
        //判断环境
        getEnv() {
            let ua = window.navigator.userAgent.toLowerCase(),
                app = "";
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                app = "weixin";
            } else if (ua.indexOf("yydh_android") !== -1) {
                app = "android";
            } else if (ua.indexOf("yydh_ios") !== -1) {
                app = "ios";
            } else {
                app = "other";
            }
            return app;
        },
        toDetail(tid,title,outUrl) {
            var obj = {
                tid: tid,
                title: title,
            };
            let app = this.getEnv();
            if (app == "ios") {
              if(outUrl){
                var outurlobj = {
                  url:outUrl
                }
                window.webkit.messageHandlers.toOutUrl.postMessage(outurlobj);
              }else{
                window.webkit.messageHandlers.toDetail.postMessage(obj);
              }
            } else if (app == "android") {
                if(outUrl){
                  android.toOutUrl(outUrl);
                }else{
                  android.toDetail(tid,title);
                }
            } else {
              if(outUrl){
                window.open(outUrl);
              }else{
                window.open("/m/newsdetail/" + tid + "/" + 2);
              }
            }
        },
            wxshare(t, d) {
      let sharelink = window.location.href;
      let sharetitle = t;
      let shareimgUrl = "https://4g.dahe.cn/resources/img/wxlogo1.png";
      let sharedes = d;

      let result = fetch(
        "https://share.dahe.cn/share/yanyu?url=" + encodeURIComponent(sharelink)
      );
      result
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          let text = data.object;

          /* 微信 */
          wx.config({
            debug: false, // 开启调试模式。
            appId: text.appId, // 必填，公众号的唯一标识
            timestamp: text.timestamp, // 必填，生成签名的时间戳
            nonceStr: text.nonceStr, // 必填，生成签名的随机串
            signature: text.signature, // 必填，签名
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表
          });

          wx.checkJsApi({
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function (res) {
              // console.log(res)
            },
          });

          //需在用户可能点击分享按钮前就先调用
          wx.ready(function () {
            // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
            wx.updateAppMessageShareData({
              title: sharetitle, // 分享标题
              link: sharelink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareimgUrl, // 分享图标
              desc: sharedes, // 分享描述
              success: function () {
                // 设置成功
              },
            });

            // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
            wx.updateTimelineShareData({
              title: sharetitle, // 分享标题
              link: sharelink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareimgUrl, // 分享图标
              success: function () {
                // 设置成功
              },
            });
          });

          wx.error(function (res) {
            console.log("err: " + res);
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          });
        })
        .catch(function (ex) {
          console.log("failed", ex);
        });
    },
    },
    created() {
        this.getUserInfo();
    }
}
</script>
<style scoped lang="scss">
.special-box {
    max-width: 750px;
    width: 100%;
    margin: 0 auto 70px;
    height: auto;

    .head-box {
        width: 100%;
        // height: 355px;
        height: auto;
        // background: url('../../../static/img/special-banner.png') no-repeat center;
        // background-size: cover !important;
        overflow: hidden;
        display: flex;
        flex-direction: column-reverse;
        position: relative;
        .banner-bg {
            width: 100%;
            min-height: 9vw;
        }
        .title-box {
            width: 100%;
            height: 96px;
            background: url('../../../static/img/special-yy.png') no-repeat center top;
            background-size: cover;
            overflow: hidden;
            padding: 13px 13px 28px;
            font-weight: 600;
            font-size: 19px;
            color: #FFFFFF;
            letter-spacing: 0;
            line-height: 26px;
            text-align: justify;
            display: flex;
            align-items: center;
            position: absolute;
            bottom: 0;
        }
    }

    .summary-box {
        width: 93%;
        height: auto;
        min-height: 117px;
        background:#fff;
        background-size: 45px;
        margin: 0 auto;
        position: relative;
        top: -20px;
        padding-top: 38px;
        border-radius: 5px;
        position: relative;
        .special-zy-bg-title {
          width: 45px;
          height: 31px;
          position: absolute;
          left: 17px;
          top: -3px;
        }
        .summary {
            width: 100%;
            height: auto;
            // background: #fff;
            padding: 0 17px 17px;
            z-index: -111;
            border-radius: 5px;

            .summary-text {
                font-weight: 400;
                font-size: 15px;
                color: #333333;
                text-align: justify;
                line-height: 1.5;
            }

            .summary-num {
                font-weight: 400;
                font-size: 12px;
                color: #999999;
                margin-top: 10px;
            }
        }
    }

    .special-list {
        width: 93%;
        margin: 22px auto;
        display: flex;
        flex-wrap: wrap;
        margin-top: 0;

        a {
            display: block;
            padding: 5px 10px;
            border: 1px solid #67A4FC;
            color: #3683F7;
            font-size: 14px;
            text-align: center;
            border-radius: 3px;
            margin: 2.5px;
        }
    }

    .little-special-list {
        width: 93%;
        margin: 0 auto;

        .special-list-item {
            width: 100%;
            margin-bottom: 20px;

            .special-title {
                width: 100%;
                // height: 22px;
                // line-height: 22px;
                font-weight: 600;
                font-size: 18px;
                color: #333333;
                background: #F7F7F7 url('../../../static/img/special-title-bg.png') no-repeat left center;
                padding: 5px 0 5px 14px;
                position: sticky;
                top: -1px;
                z-index: 11;

                span {
                    display: inline-block;

                    h5 {
                        font-weight: 600;
                        font-size: 18px;
                        float: left;
                        padding-right: 10px;
                    }

                    .border-bottm {
                        display: block;
                        width: calc(100%-10px);
                        height: 6px;
                        background: #cbdefb;
                        margin-left: 18px;
                        margin-top: 20px;
                    }
                }
            }

            .news-list {
                width: 100%;
                .loading {
                  width: 100%;
                  height: 52px;
                  background: url("../../assets/images/loading-icon.png") no-repeat 238px
                    center;
                  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.07);
                  font-size: 15px;
                  font-weight: 400;
                  color: #666666;
                  border-top: 10px solid #f7f7f7;
                  text-align: center;
                  line-height: 42px;
                }
                .loading-noicon {
                  background: none;
                }
                .loading-all {
                  width: 100%;
                  height: 52px;
                  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.07);
                  font-size: 15px;
                  font-weight: 400;
                  color: #666666;
                  border-top: 10px solid #f7f7f7;
                  text-align: center;
                  line-height: 42px;
                }
                // margin-top: 10px;
                .news-item {
                    display: block;
                    width: 100%;
                    min-height: 100px;
                    padding: 10px;
                    background: #FFFFFF;
                    border-radius: 5px;
                    box-sizing: border-box;
                    margin-bottom: 10px;

                    .news-title-box {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                    }

                    .title {
                        font-size: 16px;
                        line-height: 22px;
                        color: #121212;
                        text-align: justify;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        display: -moz-box;
                        -moz-line-clamp: 2;
                        -moz-box-orient: vertical;
                        word-wrap: break-word;
                        word-break: break-all;
                        white-space: normal;
                    }

                    .sur-date {
                        font-size: 12px;
                        color: #999999;

                        span {
                            margin-right: 10px;
                        }
                    }

                    .img-box {
                        display: flex;
                        justify-content: space-between;
                        margin: 10px 0;

                        img {
                            width: 105px;
                            height: 93px;
                            margin-left: 0;
                        }
                    }

                    .img-1 {
                        margin-left: 10px;
                        width: 100px;
                        height: 80px;
                    }
                }

                .img1 {
                    display: flex;
                    justify-content: space-between;
                }

                .img2 {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                }
                .video-box {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .img-box{
                      position: relative;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      .video-img {
                        width: 88vw;
                        height: 48vw;
                        max-width: 678px;
                        max-height: 380px;
                      }
                      .video-btn {
                        width: 10.933vw;
                        height: 10.933vw;
                        max-width: 100px;
                        max-height: 100px;
                        position: absolute;
                        // left: 50%;
                        // margin-left: -5.467vw;
                        // top: 50%;
                        // margin-top: -5.467vw;
                      }
                    }
                }
            }
        }
    }

    .download {
        background: rgba(0, 0, 0, 0.7);
        position: fixed;
        bottom: 0;
        width: 100%;
        max-width: 750px;
        padding: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #fff;
        font-size: 14px;
        z-index: 12;
        div {
            display: flex;
            align-items: center;

            span {
                font-size: 16px;
            }
        }

        img {
            width: 40px;
            height: 40px;
            border-radius: 2px;
            margin-right: 10px;
        }

        a {
            background: #317dff;
            height: 30px;
            line-height: 30px;
            color: #fff;
            padding: 0 10px;
            border-radius: 2px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/m/Special.vue